export default [
  // Blank Layout
  {
    path: '/site',
    component: () => import('src/layouts/blank/Layout.vue'),

    children: [
      {
        name: 'login',
        path: 'login',
        meta: {
          title: `Welcome to CLC ${process.env.VUE_APP_DOMAIN_TITLE}`,
          isAuth: true,
        },
        component: () => import('src/pages/auth/Login.vue'),
      },
      {
        path: 'forgot-password',
        name: 'forgotPassword',
        meta: {
          title: 'Reset Password',
          isAuth: true,
        },
        component: () => import('pages/auth/ForgotPassword.vue'),
      },
      {
        path: 'change-password/:token',
        name: 'changePassword',
        meta: {
          title: 'Change Password',
          isAuth: true,
        },
        component: () => import('src/pages/auth/ChangePassword.vue'),
      },
      {
        path: 'twofactor',
        name: 'twoFactor',
        meta: {
          title: 'Two Factor authentication',
          isAuth: true,
        },
        component: () => import('src/pages/auth/TwoFactor.vue'),
      },
      {
        path: 'invite',
        name: 'invite',
        meta: {
          title: 'Invite',
          isAuth: true,
        },
        component: () => import('src/pages/auth/Invite.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'home',
    redirect: () => ({ name: 'realtimeCashflow' }),
  },
  {
    path: '/',
    component: () => import('src/layouts/blank/Layout.vue'),
    children: [
      {
        name: 'unsubscribe',
        path: 'unsubscribe',
        component: () => import('src/pages/Unsubscribe/index.vue'),
        meta: {
          title: 'Unsubscribe',
        },
      },
    ],
  },
  // Full Layout
  {
    path: '/',
    component: () => import('src/layouts/full/Layout.vue'),
    children: [
      {
        name: 'realtimeCashflow',
        path: 'real-time-cashflow',
        component: () => import('src/pages/site/RealtimeCashflow/index.vue'),
        meta: {
          title: 'Real-Time Revenue',
          requiresAuth: true,
        },
      },
      {
        name: 'needAttention',
        path: '/need-attention',
        component: () => import('src/pages/site/NeedAttention/index.vue'),
        meta: {
          requiresAuth: true,
          title: 'Data Alerts',
          blockDateChange: true,
          isDatepickerMultipleDealershipsDisabled: true,
        },
      },
      {
        name: 'budget',
        path: 'budget',
        component: () => import('src/pages/BudgetPlanner/index.vue'),
        meta: {
          title: 'Budget',
          requiresAuth: true,
          isDatepickerCustomRangeDisabled: true,
          isDatepickerMonthsOfQuarterDisabled: true,
          isDatepickerMonthsOfYearDisabled: true,
        },
      },
      {
        name: 'leadSourceRoi',
        path: 'lead-source-roi',
        component: () => import('src/pages/site/LeadSourceRoi/index.vue'),
        meta: {
          title: 'Lead Source ROI',
          requiresAuth: true,
        },
        children: [
          {
            name: 'leadSourceRoiDetails',
            path: 'detailed/:type',
            component: () => import('src/pages/site/LeadSourceRoi/components/Details/index.vue'),
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      {
        name: 'sales',
        path: 'sales',
        component: () => import('src/pages/site/Sales/index.vue'),
        meta: {
          title: 'Sales',
          layouts: ['center', 'centerFull'],
          requiresAuth: true,
        },
        children: [
          {
            name: 'salesPerson',
            path: 'person/:person',
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      {
        name: 'website',
        path: 'website',
        component: () => import('src/pages/site/Website/index.vue'),
        meta: {
          title: 'Website',
          layouts: ['center', 'centerFull'],
          requiresAuth: true,
        },
      },
      {
        name: 'ppc',
        path: 'ppc',
        component: () => import('src/pages/site/Ppc/index.vue'),
        meta: {
          title: 'PPC',
          layouts: ['center'],
          requiresAuth: true,
        },
      },
      {
        name: 'seo',
        path: 'seo',
        component: () => import('src/pages/site/Seo/index.vue'),
        meta: {
          title: 'SEO',
          layouts: ['center', 'centerFull'],
          requiresAuth: true,
        },
      },
      {
        name: 'enterpriseReporting',
        path: 'enterprise-reporting',
        component: () => import('src/pages/site/EnterpriseReporting/index.vue'),
        meta: {
          title: 'Enterprise Reporting',
          layouts: ['centerFull'],
          showEnterpriseExport: true,
          requiresAuth: true,
        },
      },
      {
        name: 'VDPReport',
        path: 'vdp-report',
        component: () => import('src/pages/site/VDPReport/index.vue'),
        meta: {
          title: 'VDP Report',
          layouts: ['centerFull'],
          requiresAuth: true,
        },
      },
      {
        name: 'serviceDash',
        path: 'service-dash',
        component: () => import('src/pages/site/ServiceDash/index.vue'),
        meta: {
          title: 'Service Dash',
          requiresAuth: true,
        },
      },
      {
        name: 'dealerOverview',
        path: 'dealer-overview',
        component: () => import('src/pages/site/DealerOverview/index.vue'),
        meta: {
          title: 'Dealer Overview',
          isShowOverviewExport: true,
          requiresAuth: true,
        },
      },
      {
        name: 'videoStatistics',
        path: 'video-statistics',
        component: () => import('src/pages/site/VideoStatistics/index.vue'),
        meta: {
          title: 'Video Statistics',
          requiresAuth: true,
          isDatepickerCustomRangeDisabled: true,
          isDatepickerMultipleDealershipsDisabled: true,
        },
      },
      {
        name: 'reportBuilder',
        path: 'report-builder',
        component: () => import('src/pages/site/ReportBuilder/ReportsList/index.vue'),
        meta: {
          title: 'Report Builder',
          requiresAuth: true,
        },
      },
      {
        name: 'reportBuilderReport',
        path: 'report-builder/report/:id',
        component: () => import('src/pages/site/ReportBuilder/Report/index.vue'),
        meta: {
          title: 'Report',
          requiresAuth: true,
        },
      },
      {
        name: 'inventoryReport',
        path: 'inventory-report',
        component: () => import('src/pages/site/InventoryReport/index.vue'),
        meta: {
          title: 'Inventory Report',
          requiresAuth: true,
          blockDateChange: true,
        },
        children: [
          {
            name: 'inventoryReportVehicleDetail',
            path: 'report/:id',
            component: () =>
              import('src/pages/site/InventoryReport/components/VehicleDetail/index.vue'),
          },
        ],
      },

      {
        title: '20 Super Group',
        path: 'g/:id',
        name: 'customGroup',
        component: () => import('src/pages/CustomGroups/CustomGroup/index.vue'),
        meta: {
          requiresAuth: true,
          customGroup: true,
          isDatepickerCustomRangeDisabled: true,
        },
      },

      {
        name: 'realtimeMarketPrice',
        path: 'real-time-market-price',
        component: () => import('src/pages/site/RealtimeMarketPrice/index.vue'),
        meta: {
          title: 'Realtime Market Price',
          requiresAuth: true,
          blockDateChange: true,
        },
      },
      {
        name: 'faq',
        path: 'faq',
        component: () => import('src/pages/Faq/index.vue'),
        meta: {
          title: 'FAQ',
          requiresAuth: true,
        },
      },
      {
        name: '404',
        path: '404',
        component: () => import('src/pages/site/404/index.vue'),
        meta: {
          title: 'Page not found',
        },
      },
    ],
  },
  // Redirect to 404 page, if no match found
  {
    path: '/:catchAll(.*)*',
    redirect: () => ({ name: '404' }),
  },
]
